module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/Right-Wheel@2x.png?0.0.53";